<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">{{ title }}</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>
<form modalContent [formGroup]="billingForm" (ngSubmit)="submit()" #formRef>
  <div class="modal-body">
    <div class="row">
      <div class="form-group col-6">
        <label for="billing-first-name" class="control-label">First name</label>
        <input class="form-control"
               type="text"
               data-recurly="first_name"
               name="firstName"
               autocomplete="given-name"
               id="billing-first-name"
               formControlName="firstName"
               [class.is-invalid]="billingForm?.get('firstName').invalid && billingForm?.get('firstName').touched"
               required>
        <control-messages [control]="billingForm?.get('firstName')"></control-messages>
      </div>
      <div class="form-group col-6">
        <label for="billing-last-name" class="control-label">Last name</label>
        <input class="form-control"
               type="text"
               data-recurly="last_name"
               name="lastName"
               autocomplete="family-name"
               id="billing-last-name"
               formControlName="lastName"
               [class.is-invalid]="billingForm?.get('lastName').invalid && billingForm?.get('lastName').touched"
               required>
        <control-messages [control]="billingForm?.get('lastName')"></control-messages>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-7">
        <label for="billing-address1" class="control-label">Street address</label>
        <input class="form-control"
               type="text"
               data-recurly="address1"
               name="address"
               autocomplete="street-address"
               id="billing-address1"
               formControlName="address"
               [class.is-invalid]="billingForm?.get('address').invalid && billingForm?.get('address').touched"
               required>
        <control-messages [control]="billingForm?.get('address')"></control-messages>
      </div>
      <div class="form-group col-5">
        <label for="billing-postal-code" class="control-label">
          <span *ngIf="billingInfo?.country === 'US'">Zip</span>
          <span *ngIf="billingInfo?.country === 'CA'">Postal code</span>
          <span *ngIf="['GB','UK'].indexOf(billingInfo?.country) > -1">Postcode</span>
          <span *ngIf="['UK','GB','CA','US'].indexOf(billingInfo?.country)===-1">Postal code</span>
        </label>
        <input class="form-control"
               type="text"
               data-recurly="postal_code"
               name="postalCode"
               autocomplete="postal-code"
               id="billing-postal-code"
               formControlName="postalCode"
               [class.is-invalid]="billingForm?.get('postalCode').invalid && billingForm?.get('postalCode').touched"
               required>
        <control-messages [control]="billingForm?.get('postalCode')"></control-messages>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="recurly-cardelements" class="control-label">Card number</label>
        <div id="recurly-cardelements" class="recurly-cardelements" #cardRef autocomplete="cc-number cc-exp-month cc-exp-year cc-csc" required></div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="billing-first-name" class="control-label">Billing Email</label>
        <input class="form-control"
               type="text"
               name="email"
               autocomplete="billing-email"
               id="billing-email"
               formControlName="email"
               [class.is-invalid]="billingForm?.get('email').invalid && billingForm?.get('email').touched"
               required>
        <control-messages [control]="billingForm?.get('email')"></control-messages>
      </div>
    </div>
    <input type="hidden" name="recurly-token" data-recurly="token">
  </div>
</form>

<div modalFooter class="modal-footer w-100">
  <div class="d-flex flex-row justify-content-between align-items-center w-100">
    <div class="d-block">
      <div id="applePayBtn" class="apple-pay-button apple-pay-button-subscribe" *ngIf="isSafari"></div>
    </div>

    <div class="d-flex flex-row align-items-center">
      <button class="btn btn-info mr-2"
              angularticsCategory="account"
              angulartics2On="click"
              angularticsAction="Edit Billing Information"
              type="submit"
              (click)="submit()"
              [disabled]="!billingForm?.valid || !cardDataValid">Confirm</button>
      <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
